/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import React from "react";

import { NumberCell } from "../Number";

export const ORDER_DETAIL_BILLING_COLUMNS = [
  {
    Header: "Code",
    accessor: "Product.ProductCode",
    id: "ProductProductCode",
    Cell: ({ cell }) => <a>{cell.value}</a>
  },
  {
    Header: "Description",
    accessor: "Description",
    id: "Description"
  },
  {
    Header: "Category",
    accessor: "Product.ProductCategory.CodeDescription",
    id: "ProductCategoryDescription"
  },
  {
    Header: "Rate",
    accessor: "Rate",
    id: "Rate",
    Cell: ({ cell }) => <NumberCell value={cell.value} />
  },
  {
    Header: "UOM",
    accessor: "UnitOfMeasurement.CodeDescription",
    id: "UOM",
    Cell: ({ cell }) => <NumberCell value={cell.value} />
  },
  {
    Header: "%",
    accessor: "Percentage",
    id: "Percentage",
    Cell: ({ cell }) => <NumberCell value={cell.value} />
  }
];

const getClassName = (row, orderDetails) => {
  if (row?.original?.Product?.ProductCode === "FUELSC") {
    return orderDetails.some(
      oProduct =>
        oProduct.ProductRecIdRef === row.original.Product.RecId &&
        oProduct.Percentage === row.original.Percentage
    )
      ? "equal"
      : "different";
  }
  return orderDetails.some(
    oProduct =>
      oProduct.Product.RecId === row.original.Product.RecId &&
      oProduct.Rate === row.original.Rate &&
      oProduct.UOMRecIdRef === row.original.UOMRecIdRef
  )
    ? "equal"
    : "different";
};

export const PRODUCT_DETAIL_BILLING_COLUMNS = orderDetails => [
  {
    Header: "Code",
    accessor: "Product.ProductCode",
    id: "ProductProductCode",
    Cell: ({ cell, row }) => (
      <p className={getClassName(row, orderDetails)}>{cell.value}</p>
    )
  },
  {
    Header: "Description",
    accessor: "ProdDescription",
    id: "ProdDescription",
    Cell: ({ cell, row }) => (
      <p className={getClassName(row, orderDetails)}>{cell.value}</p>
    )
  },
  {
    Header: "Category",
    accessor: "Product.ProductCategory.CodeDescription",
    id: "ProductCategoryDescription",
    Cell: ({ cell, row }) => (
      <p className={getClassName(row, orderDetails)}>{cell.value}</p>
    )
  },
  {
    Header: "Rate",
    accessor: "Rate",
    id: "Rate",
    Cell: ({ cell, row }) => (
      <NumberCell
        className={getClassName(row, orderDetails)}
        value={cell.value}
      />
    )
  },
  {
    Header: "UOM",
    accessor: "UOM.CodeDescription",
    id: "UOM",
    Cell: ({ cell, row }) => (
      <NumberCell
        className={getClassName(row, orderDetails)}
        value={cell.value}
      />
    )
  },
  {
    Header: "%",
    accessor: "Percentage",
    id: "Percentage",
    Cell: ({ cell, row }) => (
      <NumberCell
        className={getClassName(row, orderDetails)}
        value={cell.value}
      />
    )
  }
];
